















































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SimplePopup extends Vue {
  @Prop() private title!: string;

  @Prop() private text!: string;

  @Prop({ default: 'Save' }) private saveBtnName!: string;

  @Prop({ default: 'Cancel' }) private cancelBtnName!: string;

  private loading = false;

  private save() {
    this.loading = true;
    this.$emit('save');
  }
}
